import * as React from 'react';

import styled, { css } from 'styled-components';

import { ImageRetry } from '../image-retry';

export interface SquareImgProps {
  className?: string;
  srcImg?: string;
  altImg?: string;
  small?: boolean;
  size?: number;
  borderRadius?: number;
}

const SquareImg: React.FC<SquareImgProps> = (props) => (
  <ImageRetry
    className={props.className}
    src={props.srcImg}
    alt={props.altImg}
  />
);

export default styled(SquareImg)`
  width: ${(props) => (props.size ? props.size : 156)}px;
  height: ${(props) => (props.size ? props.size : 156)}px;
  object-fit: cover;
  background-color: ${({ theme }) => theme.colors.differentBackground};
  border-radius: ${(props) =>
    props.borderRadius ? `${props.borderRadius}px` : '10px'};

  ${(props) =>
    props.small
      ? css`
          width: 40px;
          height: 40px;
          border-radius: 4px;
        `
      : null}
`;
